module.exports = "/_next/static/images/brand-9028747fb94a190ad6e4f1ac88679226.svg";